export default "__VITE_ASSET__qfhtEiuY__"